<script>
import { mapState, mapActions, mapMutations } from 'vuex';
export default {
  name: 'Login',
  computed: {
    ...mapState('administrator/me', [
      'item',
      'errors',
    ]),
    email: {
      set (email) {
        this.setEmail(email);
      },
      get () {
        return this.item.email;
      },
    },
    password: {
      set (password) {
        this.setPassword(password);
      },
      get () {
        return this.item.password;
      },
    },
  },
  methods: {
    ...mapActions('administrator/me', [
      'login',
    ]),
    ...mapMutations('administrator/me', [
      'setEmail',
      'setPassword',
    ]),
  },
};
</script>
<style lang="scss" scoped>
@import '../../../styles/public';
</style>
<template>
  <div class="container-fluid pre-app">
    <div class="row d-flex vh-100">
      <div class="col-xl-8 content-wrapper">
        <div class="content">
          <h2>Administrator Panel</h2>
          <p>
            Manage Your Application
          </p>
        </div>
      </div>
      <div class="col-xl-4 form d-flex flex-column">
        <div class="content flex-grow-1">
          <div class="logo text-center mb-3">
            <h1>Ineo</h1>
          </div>
          <h2 class="text-center mb-5">Login into Your Admin Panel</h2>
          <div class="form-group">
            <label for="email" class="col-12">Email</label>
            <input id="email" type="email" class="form-control form-control-lg" placeholder="example@domain.com" v-model="email" />
          </div>
          <div class="form-group">
            <label for="password" class="col-12">Password</label>
            <input id="password" type="password" class="form-control form-control-lg" placeholder="******" v-model="password" />
          </div>
          <div class="text-center mt-5">
            <button class="btn btn-mediumSlateBlue btn-lg btn-pill" @click="login">
              Login
            </button>
          </div>
          <div class="mt-3 text-center" v-if="errors.length > 0">
            <span class="text-color-mediumSlateBlue font-weight-bold" v-for="(error, index) in errors" :key="index">{{ error }}</span>
          </div>
        </div>
        <div class="version text-right text-color-silverChalice">
          Version: 0.1.0 beta
        </div>
      </div>
    </div>
  </div>
</template>
